<template lang="pug">
  .card
    h5.card-header Apply for a service dog
    .card-body
      p.card-text Are you looking for a Service Dog to help you with mobility or hearing issues? Apply for one of our highly trained dogs by filling out our application here.
      | If you have any questions about the application process, please check our&nbsp;
      a(href='/#/about/faq') FAQ
      | &nbsp;page or feel free to&nbsp;
      a(href='/#/contact') contact
      | &nbsp;us
    //- a.btn.btn-primary.card-button(href="#") Go somewhere
</template>

<script>
export default {
  name: 'ApplyForServiceDogCard'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ApplyForServiceDogCard.vue